import {EventEmitter} from 'eventemitter3'

export const supportTeamEvent = new EventEmitter()

export const supportTeamEventTypes = {
    TABLE_CHANGE: 'TABLE_CHANGE',
    USER_SUPPORT_TEAM_CHANGE: 'USER_SUPPORT_TEAM_CHANGE',
}

export function getSupportTeamEventKey(eventType, clientId) {
    if (!eventType) {
        return ''
    }

    switch (eventType) {
        case supportTeamEventTypes.TABLE_CHANGE:
            return `SUPPORT_TEAM_TABLE_CHANGE`
        case supportTeamEventTypes.USER_SUPPORT_TEAM_CHANGE:
            return `USER_SUPPORT_TEAM_CHANGE`
        default:
            return ''
    }
}

//#region TABLE CHANGE
export function onSupportTeamTableChangeListener(
    eventType = supportTeamEventTypes.TABLE_CHANGE,
    data,
) {
    supportTeamEvent.emit(getSupportTeamEventKey(eventType), data)
}

export function onSupportTeamTableChangeRemoveListener(
    eventType = supportTeamEventTypes.TABLE_CHANGE,
) {
    supportTeamEvent.removeListener(getSupportTeamEventKey(eventType))
}
//#endregion

//#region DETAIL CHANGE
export function onUserSupportTeamDetailChangeListener(
    eventType = supportTeamEventTypes.USER_SUPPORT_TEAM_CHANGE,
    data,
) {
    supportTeamEvent.emit(getSupportTeamEventKey(eventType), data)
}

export function onUserSupportTeamDetailChangeRemoveListener(
    eventType = supportTeamEventTypes.USER_SUPPORT_TEAM_CHANGE,
) {
    supportTeamEvent.removeListener(getSupportTeamEventKey(eventType))
}
//#endregion
